import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { routeFor, routes as globalRoutes } from 'src/core/constants/routes';

export const ControlSettingsCostCenters = () => {
  const history = useHistory();
  const companyId = useCompanyId();

  useEffect(() => {
    // Redirect to the cost center settings page where users can actually set up cost centers
    const costCenterSettingsPath = routeFor(globalRoutes.COST_CENTERS.path, {
      company: companyId,
    });
    history.replace(costCenterSettingsPath);
  }, [companyId, history]);

  return null;
};
